import ReactQueryRailsWrapper from './ReactQueryRailsWrapper';

export default ReactQueryRailsWrapper;
